/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Drevet av Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Drevet av AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Innholdet er basert på tillatelsene dine, og kvaliteten på det kan variere',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Kvaliteten på innholdet kan variere',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informasjon',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Inkluder kunnskap fra gjeldende side',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence-logo',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Tilbake',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Avbryt',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Avbryt',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Avbryt',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Dårlig svar',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Tilbakemeldingen er sendt',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Godt svar',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Fortsett fra forrige svar',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopier',
  'fabric.editor.ai.config.item.action.responseCopied': 'Kopiert!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Kopiert til utklippstavle',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Prøv igjen',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vi har problemer med å sette inn svaret. Lukk dialogboksen og prøv igjen.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Vi fikk ikke svar. Ledeteksten eller svaret ditt var over grensen for denne forespørselen. Lukk dialogboksen og prøv igjen.',
  'fabric.editor.ai.experience.apiError': 'Vi fikk ikke svar. Prøv igjen.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'Innholdet er for kort til å oppsummeres. Legg til mer og prøv igjen.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Genererer',
  'fabric.editor.ai.experience.previewScreenLabel': 'Forhåndsvisning',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Be agenten om å skrive noe, eller velg blant alternativene nedenfor',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-logo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Tilbake',
  'fabric.editor.ai.screens.discard.discardLabel': 'Forkast',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Advarsel',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Feil',
  'fabric.editor.ai.screens.error.cancelLabel': 'Avbryt',
  'fabric.editor.ai.screens.error.retryLabel': 'Prøv igjen',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Direkte oppdatering av innhold:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Genererer ikon',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Avbryt',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Fortell AI hva den skal gjøre videre',
  'fabric.editor.ai.screens.preview.discardLabel': 'Forkast',
  'fabric.editor.ai.screens.preview.disclaimer': 'Kvaliteten på informasjonen kan variere.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Finn ut hvorfor',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Tøm',
  'fabric.editor.ai.screens.preview.header.edit': 'Rediger ledetekst',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Rediger',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Spør {agentName} om hva du skal gjøre videre',
  'fabric.editor.ai.screens.preview.refineButton': 'Avgrens',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Avgrens',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence-logo',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Send inn',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Send inn til AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} – Valgt',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Fjern',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Forslag',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Skriveassistent',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'La Atlassian Intelligence hjelpe med skrivingen',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Skriv',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NY',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Si til AI:',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Si til agenten',
};
